import { Asset } from './asset';
import { Costing } from './costing';
import { Location } from './location';
import { RepairRecord } from './repairs';
import { Tag } from './tag';
import { WorkOrder } from './workorder';

export enum IssueStatus {
  Open = 'open',
  Closed = 'closed',
}

export enum IssueSource {
  Inspection = 'inspection',
  Service = 'service',
  Manual = 'manual',
}

export enum IssueSeverity {
  Critical = 'critical',
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

export type GetIssuesDto = {
  data: GetIssueDto[];
  count: number;
};

export type GetIssueDto = {
  ref: string;
  id: string;
  fieldReference: string;
  title: string;
  asset: { id: string; label: string; tags?: Tag[] };
  location: string;
  createdAt: string;
  closedAt: string;
  reportedBy: string;
  createdById: string;
  resolvedBy?: string;
  source: IssueSource;
  severity: IssueSeverity;
  status: IssueStatus;
  workorder?: WorkOrder;
  description: string;
  count: number;
  cause: string;
  parts: string;
  tests: string;
  comments: string;
};

export type Issue = {
  id: string;
  fieldReference: string;
  asset: Asset;
  location: Location;
  createdAt: Date;
  updatedAt: Date;
  closedAt: Date;
  reportedBy: string;
  createdById: string;
  resolvedBy?: string;
  source: IssueSource;
  severity: IssueSeverity;
  status: IssueStatus;
  description: string;
  count: number;
  cause: string;
  parts: string;
  tests: string;
  ref: string;
  photos?: string[];
  comments?: string;
  url?: string;
  workorder?: WorkOrder;
  costing?: Costing[];
  repair?: RepairRecord;
  tags?: Tag[];
};

export type UpdateIssueDto = {
  fieldReference?: string;
  severity?: IssueSeverity;
  status?: IssueStatus;
  description?: string;
  asset?: string;
  location?: string;
  file?: File;
  comments?: string;
};

export type CreateIssueDto = {
  fieldReference: string;
  severity: IssueSeverity;
  status: IssueStatus;
  description: string;
  assetId: string;
  locationId?: string;
  photos?: string[];
};
